import http from "./httpService";

const endPoint = "/api/v1/CostCategory";

export async function getAllCostCategory() {
    return await http.get(`${endPoint}`);
}

export default { getAllCostCategory };


// WEBPACK FOOTER //
// ./src/services/CostCategoryService.js